<template>
  <div>
    <div class="card">
      <div class="card-action white white-text"></div>
      <div class="card-content animated flipInX">
        <h5>Generate Account Number</h5>
        <p>Enter your merchant ID and phone number below.</p>
        <form @submit.prevent="requestToken" id="form" style="margin-top: 30px">
          <div class="row">
            <div class="input-field col s12 m8 offset-m2">
              <input type="text" v-model="fields.vendor_id" id="meter_number" />
              <label for="meternumber">Merchant ID</label>
            </div>
          </div>
          <div class="row">
            <div class="input-field col s12 m8 offset-m2">
              <input type="text" v-model="fields.phone" id="phone" />
              <label for="phone">Phone Number</label>
            </div>
          </div>
          <div class="row">
            <div v-if="reissue">
              <img src="ui/img/loading.svg" alt="Time Loader" />
              <p><i>Loading...</i></p>
            </div>
            <div class="col s12 m12" v-else>
              <button class="waves-effect waves-light btn-small" type="submit">
                Generate Account
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <!-- Request Token -->
    <div id="requestToken" class="modal services">
      <div class="modal-header">
        <a class="modal-close waves-effect btn-small waves-green right">x</a>
      </div>
      <div class="modal-content">
        <img src="ui/img/success.png" width="12%" class="responsive-img" />
        <h5><strong>Bank Name:</strong>&nbsp;&nbsp;&nbsp;{{ completed.bank_name }}</h5>
        <h6><strong>Account_name:</strong>&nbsp;&nbsp;&nbsp;{{ completed.account_name }}</h6>
        <h6><strong>Account Number:</strong>&nbsp;&nbsp;&nbsp;{{ completed.account_number }}</h6>
      </div>
    </div>
    <!-- Request Token -->
  </div>
</template>
<script>
export default {
  name: 'VendorAccount',
  mounted() {
    this.initModal()
    $('.bills__side__wrapper').removeClass('left_out')
    if (localStorage.getItem('phone') !== null) {
      var phone = localStorage.getItem('phone')
      this.fields.phone = phone
      $('#phone').val(phone)
    }
    M.updateTextFields()
  },
  data() {
    return {
      reissue: false,
      fields: {},
      modalInstance: {},
      completed: {}
    }
  },
  methods: {
    formatNumber(num) {
      var result = num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
      return result
    },
    initModal() {
      // initialize modal for the document
      const option = {
        dismissible: false,
        endingTop: '6%',
        preventScrolling: true
      }
      var elems = document.querySelectorAll('.modal.services')
      var instances = M.Modal.init(elems, option)
      this.modalInstance = instances
    },
    doCopy: function() {
      let container = this.$refs.container
      this.$copyText(this.completed.token, container)
      $('.copyBtn').text('Copied')
      setTimeout(() => {
        $('.copyBtn').text('Click to copy')
      }, 3000)
    },
    requestToken() {
      if (this.ValidateData()) {
        this.reissue = true
        this.fields.passcode = this.hash(this.fields.vendor_id)
        this.axios
          .post('https://irecharge.com.ng/api/misc/provision_account.php', this.fields)
          .then(response => {
            if (response.data.status == 0) {
              this.completed.account_name = response.data.account_name
              this.completed.account_number = response.data.account_number
              this.completed.bank_name = response.data.bank_name
              this.modalInstance[0].open()
              this.reissue = false
              $('.toast').hide()
            } else {
              this.reissue = false
              $('.toast').hide()
              M.toast({ html: response.data.message, classes: 'info' })
            }
          })
          .catch(error => {
            $('.toast').hide()
            M.toast({
              html: 'Could not send request, check network.',
              classes: 'error'
            })
            this.reissue = false
          })
      }
    },
    ValidateData() {
      if (this.fields.vendor_id) {
        if (this.fields.phone) {
          // if (this.fields.phone.toString().length === 11) {
            return true
          // } else {
          //   $('.toast').hide()
          //   M.toast({
          //     html: 'Phone number must be 11 characters',
          //     classes: 'info'
          //   })
          // }
        } else {
          $('.toast').hide()
          M.toast({ html: 'Phone number is required!', classes: 'info' })
        }
      } else {
        $('.toast').hide()
        M.toast({ html: 'Meter number is required!', classes: 'info' })
      }
    },
    hash(ref) {
      let passcode = '123NDSx'
      let encrypted = CryptoJS.HmacSHA512(ref, passcode)
      return encrypted.toString()
    }
  }
}
</script>
<style scoped>
label {
  font-size: 1rem;
  color: #9e9e9e;
  font-weight: bold;
}
.card-content {
  padding: 0px 24px 24px;
}
.card .card-action {
  padding: 6px 24px;
}
.input-field {
  margin-top: 0px;
}
</style>
